/*
 * @Author: wangbaihe
 * @Date: 2023-04-28 10:36:47
 * @LastEditors: wangbaihe
 * @LastEditTime: 2025-12-18 10:34:26
 * @FilePath: \common-mediax\src\apis\MediaCloudArticleOrigin\ArticleEdit.js
 * @Description: 追加稿源库的详情页按钮配置
 */
import { createAPI } from '@common'
// MediaCloudArticleOriginEdit
export default {
  preAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60bdujpot0qsfbdujpo', 'post', config, {
      neverLoading: true
    }),
  postAction: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60bdujpot0qptubdujpo', 'get', config, {
      neverLoading: true
    }),
  // 提交审核
  postFinalSend: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0tvcnju0bveju',
      'post',
      config
    ),
  // 获取送审并发布渠道（未发布状态也可以获取
  getTransPubInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0hfuUsbotQvcJogp',
      'GET',
      config
    ),
  // 审核完成
  postArticlePass: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0qbtt', 'post', config),
  // 驳回审核
  postArticleReject: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0sfkfdu', 'post', config),
  // 修改痕迹 - 所有
  getAllArticlesTraces: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0bmm', 'get', config),
  // 获取不同用户修改痕迹
  getArticlesTracesByDifUserNew: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0bmufsobuf',
      'get',
      config,
      vconfig
    ),
  // 根据指定用户获取修改痕迹 - 未使用
  getArticlesTracesBySameUser: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0vtfst0tbnf', 'get', config),
  // 根据选择版本获取修改痕迹
  getArticlesTracesByVersion: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0wfstjpo0usbdf0wfstjpot0tfmfdu',
      'get',
      config,
      vconfig
    ),
  // 删除
  postArticleDelete: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0efmfuf', 'post', config),
  postArticleProof: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0qsppg', 'post', config),

  getForwardLogs: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0gpsxbse0mpht',
      'post',
      config
    ),
  // 签发稿件到报纸
  postPaperArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0qbqfs0tjho0gpsxbse', 'post', config, {
      timeout: 90000
    }),
  // 获取稿件发布设置信息
  getArticlesPubInfo: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0qvcJogp', 'GET', config),
  // 签发稿件到期刊
  postJournalArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0kpvsobm0tjho0gpsxbse', 'post', config, {
      timeout: 90000
    }),
  // 签发稿件到全媒体采编发（发布用的也是这个接口
  postArticlesForward: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0bsujdmft0jttvf', 'post', config, {
      timeout: 90000
    }),
  getRootFolderRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0gpmefs0sppu', 'get', config),
  // 获取树节点
  getRootArticlesTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60gpmefst', 'get', config),
  // 获取联级树节点
  getRootFolderTree: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0gpmefs0usff', 'get', config),
  // 送审
  postRootArticlesTransfer: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0usbotgfs', 'post', config),
  // 移动
  postRootArticlesMove: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0npwf', 'post', config),
  // 稿件详情
  getDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0bsujdmft0efubjm', 'get', config, {
      timeout: 90000
    }),
  // 稿源库-写稿初始化
  getInit: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0bsujdmft0dsfbujpo0joju', 'get', config),
  // 稿源库-写稿保存
  postSave: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0bsujdmft0dsfbuf', 'post', config, {
      ...vconfig,
      isSimpleSecurity: true
    }),
  // 稿源库-详情页操作权限
  getArticlesActions: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0f60bdujpot0efubjmbdujpot', 'get', config),
  // 稿源库签发到畅享全媒体稿源稿库接口
  signRemoteRootForward: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0ofxtfeju0tjho0sppu0gpxbse',
      'post',
      config,
      {
        timeout: 90000
      }
    ),
  // 稿源库签发到畅享全媒体部门库接口
  signRemoteEditForward: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0ofxtfeju0tjho0feju0gpxbse',
      'post',
      config,
      {
        timeout: 90000
      }
    ),
  // 新-稿件预览
  postNewPreview: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0bsujdmft0bqqQsfWjfx', 'post', config),
  // 判断是否有回收站权限
  getRecycleRoot: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0bsujdmf0hfuSfdzdmf', 'get', config),

  // 还原已删除稿件
  postArticleRevert: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0bsujdmfSfwfsu',
      'post',
      config,
      vconfig
    ),
  // 彻底删除已删除稿件
  postArticleDeleteReal: (config, vconfig) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0efmfufSfbm',
      'post',
      config,
      vconfig
    ),
  // 小样重稿-获取文章相似稿列表
  getSimilarList: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0tjnjmbs0mjtuebub', 'get', config),
  // 小样重稿-获取文章相似稿详情
  getSimilarDetail: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0tjnjmbs0efubjm', 'get', config),
  // 稿件详情
  getArticlesDetails: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0bsujdmft0efubjm', 'get', config, {
      timeout: 90000
    }),
  // 查看权限消息
  getDetailStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0bsujdmft0efubjm0tubuvt', 'get', config),
  // 查看权限 待办
  getAssignStatus: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0bsujdmft0bttjho0tubuvt', 'get', config),
  // 为打印功能定制的 批量查询稿件信息接口（柳爱霞
  postArticlePrint: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0qsjou', 'post', config),
  // 重发接口地址
  postOriginRePublish: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0bsujdmft0sfQvcmjti', 'POST', config),
  // 重发获取可重发渠道
  getOriginRePubChannels: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.benjo0bttpdjbujpo0hfuSfQvcDiboofmt', 'get', config),
  // 归档
  postArticlePOF: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0bsujdmfQPG', 'POST', config),
  // 重复归档提示
  postCheckPOF: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0difdlQPG', 'POST', config),
  // 收藏
  postArticleCollect: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.bsujdmfpsjhjo0sppuBsujdmft0dpmmfdu', 'POST', config)
}
